/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mycompanyllc2Inputs */

const en_mycompanyllc2 = /** @type {(inputs: Mycompanyllc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Company LLC`)
};

const de_mycompanyllc2 = /** @type {(inputs: Mycompanyllc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meine Firma LLC`)
};

/**
* | output |
* | --- |
* | "My Company LLC" |
*
* @param {Mycompanyllc2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const mycompanyllc2 = /** @type {((inputs?: Mycompanyllc2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mycompanyllc2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mycompanyllc2(inputs)
	return de_mycompanyllc2(inputs)
});
export { mycompanyllc2 as "myCompanyLlc" }